import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from '@shared/modules/button/button.module';
import { LinkModule } from '@shared/modules/link/link.module';
import { SectionModule } from '@shared/modules/section/section.module';
import { SharedModule } from '@shared/shared.module';
import { ValidationModule } from '@shared/modules/validation/validation.module';
import { LoaderModule } from '@shared/modules/loader/loader.module';

import { LoginFormFactory } from './shared/login-form.factory';
import { LoginComponent } from './container/login.component';
import { LoginRoutingModule } from './login-routing.module';

@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    LoginRoutingModule,
    ButtonModule,
    LinkModule,
    SectionModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    ValidationModule,
    LoaderModule,
  ],
  providers: [
    LoginFormFactory,
  ]
})
export class LoginModule { }

